import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c037f0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("PC端")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("移动端")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("无")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_ParamsSet = _resolveComponent("ParamsSet")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "菜单配置" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "name",
            label: "菜单名称",
            name: "name",
            rules: _ctx.rules.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                allowClear: "",
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            ref: "subtitle",
            label: "菜单副标题",
            name: "subtitle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.subtitle,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.subtitle) = $event)),
                allowClear: "",
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "is_pc",
            label: "终端",
            name: "is_pc",
            rules: [{ required: true, message: '请选择终端' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.is_pc,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.is_pc) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "image",
            label: "菜单图标",
            name: "image"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.image) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onImageChange,
                    "source-url": _ctx.formState.image
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "type",
            label: "菜单类型",
            name: "type",
            rules: [{ required: true, message: '请选择菜单类型' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.type,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.type) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuType, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "pid",
            label: "父级菜单",
            name: "pid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.pid,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.pid) = $event)),
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _ctx.filterOption,
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, {
                    value: 0,
                    label: "无"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id,
                      label: item.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "link_address",
            label: "跳转页面",
            name: "link_address",
            rules: [{ required: true, message: '请选择跳转链接' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.link_address,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.link_address) = $event)),
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _ctx.filterOption,
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictionary, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id,
                      label: item.name+'（'+ (item.terminal === 1 ? '移动端' : 'PC端') +'）'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name) + "（" + _toDisplayString(item.terminal === 1 ? "移动端" : "PC端") + "） ", 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "params",
            label: "跳转参数",
            name: "params",
            extra: "以键值对的形式"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.params,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.params) = $event)),
                placeholder: "请输入",
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamsSet, {
                    ref: "paramsRef",
                    params: _ctx.formState.params
                  }, null, 8, ["params"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "target",
            label: "跳转方式",
            name: "target"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.target,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.target) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTarget, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "sort",
            label: "菜单排序",
            name: "sort"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.sort,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.sort) = $event)),
                allowClear: "",
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}